export default __webpack_public_path__ + "img/modal_header-8fa159d66b82087fb5ebade7ee3a86c4.png";